var map = {
	"./OLD_convergenze_logo.png": "f70d",
	"./OLD_logo.png": "2ec7",
	"./back_.png": "c4bc",
	"./convergenze_logo3.png": "8340",
	"./entra_conv.png": "66fb",
	"./entra_conv_sm.png": "14e7",
	"./go_back_icon.png": "24b2",
	"./icon_registrazioni.png": "c343",
	"./icona_div_italia.png": "8aee",
	"./icona_div_livetv.png": "0531",
	"./icona_div_mylife.png": "2029",
	"./icona_div_pandora.png": "7cd3",
	"./icona_div_tg.png": "19e4",
	"./icona_div_video.png": "3973",
	"./icona_home_pandora.png": "4013",
	"./icona_italia.png": "e33d",
	"./icona_live_tv.png": "2bbb",
	"./icona_live_tv_menu.png": "b3b4",
	"./icona_live_tv_sm.png": "3009",
	"./icona_mylife.png": "27b8",
	"./icona_prossimi_tg.png": "630d",
	"./icona_sm_home.png": "22d1",
	"./icona_territorio.png": "43d1",
	"./icona_video_makers.png": "036b",
	"./icona_ylife.png": "3dfd",
	"./icone_white.png": "c42f",
	"./isola_conv.png": "a050",
	"./isola_conv_sm.png": "4b1f",
	"./logo.png": "9d64",
	"./logo2.png": "dd88",
	"./logo_myiptv.png": "2795",
	"./logo_sm.png": "7709",
	"./news.jpg": "1777"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";